// data.js
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

export default function data(apiData = [], onEdit, onDelete) {
  return {
    columns: [
      { Header: "Broker Name", accessor: "title", align: "left" },
      { Header: "Email", accessor: "email", align: "left" },
      { Header: "Phone", accessor: "mobile", align: "center" },
      { Header: "Action", accessor: "action", align: "center" },
    ],

    rows: apiData.map((item) => ({
      title: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {item.name ?? "-"}
        </MDTypography>
      ),
      email: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {item.email ?? "-"}
        </MDTypography>
      ),
      mobile: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {item.mobile ?? "-"}
        </MDTypography>
      ),
      action: (
        <MDBox display="flex" justifyContent="center" gap={1}>
          <IconButton
            size="small"
            color="info"
            onClick={(e) => {
              e.preventDefault();
              onEdit(item);
            }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
          <IconButton
            size="small"
            color="error"
            onClick={(e) => {
              e.preventDefault();
              onDelete(item);
            }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </MDBox>
      ),
    })),
  };
}
